import { render, staticRenderFns } from "./InstitutionWidget.vue?vue&type=template&id=70e7f687"
import script from "./InstitutionWidget.vue?vue&type=script&lang=js"
export * from "./InstitutionWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports